import script from "./LeaderProjectFormRow.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormRow.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormRow.vue?vue&type=style&index=0&id=6e25c578&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e25c578"]])

export default __exports__